"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillOfMaterialSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class BillOfMaterialSearchResponse extends common_1.PaginatedResponse {
}
exports.BillOfMaterialSearchResponse = BillOfMaterialSearchResponse;
//# sourceMappingURL=bill-of-material-search.response.js.map